import React from 'react';
import NumberInput from 'semantic-ui-react-numberinput';
import { validationClasses } from '@/utils/errors';
import parseNumericValue from '@/utils/numberHelper';
import { camelConverter } from '../helper';

const FormNumber = ({
  field,
  text,
  onChange,
  disabled,
  autoFocus,
  error,
}) => {
  const valueAsNumber = parseNumericValue(text, '');
  return (
    <NumberInput
      allowEmptyValue
      autoFocus={autoFocus}
      className={validationClasses(error, 'aridhia-form-number')}
      disabled={disabled}
      id={camelConverter(field.name, '_')}
      maxValue={parseNumericValue(field.validation?.maximum) || undefined}
      minValue={parseNumericValue(field.validation?.minimum) || undefined}
      onChange={(value) => { onChange(parseNumericValue(value)); }}
      placeholder={field.placeholder}
      size="large"
      type="custom"
      value={valueAsNumber.toString()}
    />
  );
};

export default FormNumber;
